export enum TicketQueryKeys {
  LIST = "ticketList",
}
